import { possibleWinninglines } from "../Constants/PossibleWinningLines";

export function boardFull(squares) {
    for (const square of squares) {
      if (square === null)
        return "false";
    }
    return "true";
  };

  export function CalculateWinner(squares) {
    // Review an array of all possible winning combinations, if a winner
    // is found, return the list of elements that caused the win

    let winningElements = Array;
    for (const element of possibleWinninglines) {
      const [a, b, c] = element;
      if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
        winningElements = [a, b, c];
        return winningElements;
      }
    }
    return null;
  };

  export function ConvertStringToArray(testString) {
    const tempArray = Array.from(testString);
    let newArray = [];
    for (let i = 0; i< tempArray.length; i++) {
     if (tempArray[i] === '_') {
       newArray.push(null);
    } else {
     newArray.push(tempArray[i]);
    }};
    return newArray;
 };
 
 export function ConvertArrayToString(myArray) {
    let myString = "";
    for (let i = 0; i < myArray.length; i++) {
     if (myArray[i]) {
       myString += myArray[i]
     } else {
       myString += '_';
     }
    };
    return myString;
 };

     /* Given a player (X or O) and the board, determine if the player has two in a row anywhere and if so,
    return the position needed to either block the human or cause the computer to win
    */
    export function FindTwoInLine(player, squares) {
      let ourDesiredMove = -1;
      let element = null;
      for (element of possibleWinninglines) {
          const [a, b, c] = element;
          let numberOfFilledSquares = 0;
          let numberOfNullSquare = -1;        
          for (var i in element){ 
              if (squares[element[i]] === null) {
                  numberOfNullSquare = element[i];
              } else {
                  if (squares[element[i]] === player) {
                      numberOfFilledSquares++;
                  }  
              }
          }
          if ((numberOfFilledSquares > 1) && (numberOfNullSquare > -1)) {
              return numberOfNullSquare;
          }
      }
      return ourDesiredMove;
  }

export function RandomMove(squares) {
      // Look at the game board and find a random empty spot anywhere
      let foundEmptySquare = false;
      let squarePosition = 0;
      while (foundEmptySquare !== true) {
          squarePosition = Math.floor(Math.random() * 10);
          if (squares[squarePosition] === null) {
              foundEmptySquare = true;
          }
      }
      return squarePosition;
}

export function Pause() {
  let endOfLoop = false;
  let loopCounter = 0;
  while (!endOfLoop) {
    loopCounter++;
    if (loopCounter > 100000000) {
        endOfLoop = true;
    }
  }
}